import { render } from "./DeleteRequestOkImage.vue?vue&type=template&id=b6561cb0"
const script = {}

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__